import { createContext, useContext, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { getPreviewHash } from '../utils/isPreview';
import { jsx as _jsx } from "react/jsx-runtime";
const NavigationContext = /*#__PURE__*/createContext(null);
export function NavigationProvider({
  children
}) {
  const history = useHistory();
  const listingsSearchRef = useRef('');
  const saveListingsSearch = useCallback(search => {
    listingsSearchRef.current = search;
  }, []);
  const backToListings = useCallback(() => {
    history.push({
      pathname: '/',
      search: listingsSearchRef.current,
      hash: getPreviewHash()
    });
  }, [history]);
  return /*#__PURE__*/_jsx(NavigationContext.Provider, {
    value: {
      history,
      saveListingsSearch,
      backToListings
    },
    children: children
  });
}
export function useNavigationContext() {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationProvider');
  }
  return context;
}